import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environment';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from './config.service';

@Injectable({
    providedIn: 'root',
})
export class VersionApiService {

    constructor(
        protected http: HttpClient,
        private config: ConfigService
    ) {}

  getVersion(): Observable<string> {
    return this
      .http
      .get<string>(this.config.apiEndpoint + environment.api_version);
  }
}
